import type { SVGProps } from "react"

export enum SubscribeType {
	All = 0,
	Subscribe = 1, // 订阅
	Unsubscribe = -1,
}

export enum TabType {
	MY = "my",
	REGULAR = "regular",
}

export interface ISVGProps extends Partial<SVGProps<SVGSVGElement>> {
	size?: string | number
}

export interface IResponseType<T> {
	code: number
	data: T
	msg: string
}

export interface PageInfo {
	total: number
	current_page: number
	page_size: number
	page_count: number
}

export type PaginatedResult<T> = {
	info: PageInfo
	list: T[]
}

// 申请试用弹窗列表
export interface AllEnPublication {
	id: number
	name: string
	item_id: number
	item_name: string
	item_en_name: string
	cycle: number // 每日 5 每周 1 每月 2 每季度 3 每半年6  每年 4
	created_time: number
	updated_time: number
	admin_email: string
	status: number // 1正常  2禁用
	category: number
	begin_time: number
	end_time: number
	publication_child_count: number
	subscribe_count: number
	last_updated_time: number
	sort_number: number
	has_subscribed: number // 1订阅 0未订阅
	service_id: number
	priority_level: number
	cover_pic: string
	preview_file_path: string
	preview_file_name: string
	if_recommend: number
	recommend_tags: string
	try_read: string
	celue_introduction: string
	price: number
	service_description: string
	duration: number
	is_new: number
}

// 报告
export interface ReportsItem {
	updated_time: number // 最近更新时间
	last_updated_time: number // 最近更新时间
	cover_pic: string // 封面
	has_subscribed: number // 当前是否订阅  1订阅 0未订阅
	item_id: number
	item_name: string
	item_en_name: string // 品目
	cycle: number // 更新频率 5:每日 1:每周,2:每月,3:每季度,4:每年
	name: string // 报告类别名称
	service_introduction: string
	celue_introduction: string
	status: number // 状态 1 启用 2 禁用
	is_stop: number // 是否停更 0 正常 1 停更
	view_url?: string // 查看报告
	id: number
	attachment_type?: string // 报告类型
	team_member_id: string // 团队成员id
	sample_file_path?: string // 报告样本链接
	has_auth?: number // 品类权限：1 有权限，0 无权限
}

export interface ReportSubscribe {
	count: number
	subscribe_manage_list: ReportSubscribeItem[]
}
export interface ReportSubscribeItem {
	id: number
	user_id: number
	email: string
	publication_id: number
	publication_name: string
	begin_time: number
	end_time: number
	category: number
	source: string
	is_tryout: number
	status: number
	admin_email: string
	created_time: number
}

// 品目列表
export interface ItemList {
	id: number
	name: string
	en_name: string // 英文名
	sort_number: number
	create_time: number
	admin_emial: string
	status: number // 1正常  2禁用
	has_power: number // 1有权限 0无权限
}

// 月度周度列表
export interface CycleItem {
	id: number
	en_name: string
}

// 报告详情列表
export interface ReportsDetailItem {
	cover_pic: string
	id: number
	publication_id: number
	updated_time: number // 更新日期
	last_updated_time: number // 更新日期
	status: number
	name: string // 报告名称
	cycle: number
	item_id: number
	item_en_name: string
	has_auth: number // 是否有权限（订阅）0无权限,1有权限
	view_url: string
	attachment_type: string // 报告类型
}

// 详情筛选
export interface SubScribedYearItem {
	value: number
	label: string
	id: number
	en_name: string
}

export interface ReportCycle {
	cycle: number
	name: string
}

export interface ReportMemberItem {
	id: number
	name: string
	position: string
	avatarUrl: string
	createdAt: string
	createdBy: string
	phone: string
	phone_area_code: string
	whats_app_url: string
}

export interface ReportSample {
	publication_id: number
	file_name: string
	signed_url: string
	item_id: number
	item_name: string
	has_submitted: boolean
}

/** 报告样本试用申请提交参数 */
export interface ReportSampleApplication {
	item_ids: number[]
	publication_id?: number
	first_name?: string
	last_name?: string
	country?: string
	company?: string
	job_title?: string
	industry?: string
	email?: string
	phone_number?: string
	message?: string
}
